import GoogleAuthModal from './GoogleAuthModal'
export default GoogleAuthModal